import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  icon?: string;
  children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  isLoading = false,
  icon,
  children,
  className = '',
  disabled,
  ...props
}) => {
  const baseClasses = 'inline-flex items-center justify-center gap-2 font-bold rounded-pill transition-all';

  const variantClasses = {
    primary: 'bg-brand-black text-white hover:bg-brand-pink border border-brand-black',
    secondary: 'bg-brand-aqua text-brand-black hover:bg-brand-mustard border border-brand-aqua',
    outline: 'bg-white text-brand-black border-2 border-brand-grey01 hover:border-brand-pink hover:text-brand-pink',
    ghost: 'bg-brand-grey01 text-brand-black hover:bg-brand-grey02 border border-brand-grey02'
  };

  const sizeClasses = {
    sm: 'px-4 py-2 text-xs',
    md: 'px-5 py-3 text-sm',
    lg: 'px-6 py-4 text-base'
  };

  const disabledClasses = disabled || isLoading ? 'opacity-50 cursor-not-allowed' : '';

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${disabledClasses} ${className}`}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <>
          <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
          {children}
        </>
      ) : (
        <>
          {icon && <span className="material-symbols-outlined text-sm">{icon}</span>}
          {children}
        </>
      )}
    </button>
  );
};

export default Button;
